import Header from "./Header";
import React from "react";
import Footer from "./Footer";

export const Impressum = () => {
    return (
        <div>
            <div className="mx-auto">
                <div className="intro">
                    <Header/>
                    {/*<Intro/>*/}
                </div>
            </div>
            <div className="p-5 max-w-xl rounded-lg shadow-lg">
                <h1 className="text-2xl font-bold text-white-800 mb-4">Impressum</h1>

                <div className="mb-6">
                    <p className="text-lg font-semibold text-gray-700">ubion GmbH</p>
                    <p className="text-gray-600">Uhdestraße 25</p>
                    <p className="text-gray-600">08056 Zwickau, Germany</p>
                </div>

                <div className="mb-6">
                    <p className="text-lg font-semibold text-gray-700">Handelsregister: HRB 36872</p>
                    <p className="text-gray-600">Registergericht: Amtsgericht Chemnitz</p>
                    <p className="text-gray-600">Firmensitz: Zwickau</p>
                </div>

                <div className="mb-6">
                    <p className="text-lg font-semibold text-gray-700">Vertretungsberechtigt:</p>
                    <ul className="list-disc list-inside text-gray-600">
                        <li>Manoel Kraus</li>
                        <li>Daniel Franke</li>
                        <li>Felix Palm</li>
                        <li>Sebastian Junghans</li>
                    </ul>
                </div>

                <div className="mb-6">
                    <p className="text-lg font-semibold text-gray-700">Kontakt:</p>
                    <p className="text-gray-600">Telefon: <a href="tel:+4937527219770"
                                                             className="text-blue-600 hover:underline">+49 375 27 21 97
                        70</a></p>
                    <p className="text-gray-600">E-Mail: <a href="mailto:info@ubi-on.com"
                                                            className="text-blue-600 hover:underline">info@ubi-on.com</a>
                    </p>
                </div>

                <div className="mb-6">
                    <p className="text-lg font-semibold text-gray-700">Umsatzsteuer-ID: DE400497459</p>
                    <p className="text-medium font-semibold text-gray-700">Umsatzsteuer-Identifikationsnummer gemäß § 27
                        a
                        Umsatzsteuergesetz</p>
                </div>

                <div>
                    <h1 className="text-2xl font-bold text-gray-800 mb-4">Verantwortlich für den Inhalt</h1>
                    <p className="text-gray-600 mb-6">
                        ubion GmbH, Uhdestraße 25, 08056 Zwickau, Deutschland
                    </p>

                    <h2 className="text-xl font-semibold text-gray-800 mb-4">Online-Streitbeilegung</h2>
                    <p className="text-gray-600 mb-6">
                        Die EU-Kommission hat eine Online-Plattform für außergerichtliche
                        Streitschlichtung bereitgestellt (<span className="font-semibold">OS-Plattform</span>).
                        Verbrauchern gibt dies die Möglichkeit, Streitigkeiten im Zusammenhang mit Ihrer
                        Online-Bestellung zunächst ohne die Einschaltung eines Gerichts zu klären.
                        Die Streitbeilegungs-Plattform ist unter dem externen Link: <a
                        href="https://ec.europa.eu/consumers/odr/"
                        className="text-blue-600 hover:underline">https://ec.europa.eu/consumers/odr/</a> erreichbar.
                    </p>
                    <p className="text-gray-600 mb-6">
                        Wir sind bemüht, eventuelle Meinungsverschiedenheiten aus unserem Vertrag einvernehmlich
                        beizulegen. Darüber hinaus sind wir zu einer Teilnahme an einem
                        Streitschlichtungsverfahren nicht verpflichtet und können Ihnen die Teilnahme an einem solchen
                        Verfahren leider auch nicht anbieten. Unsere E-Mail-Adresse lautet <a
                        href="mailto:info@ubi-on.com"
                        className="text-blue-600 hover:underline">info@ubi-on.com</a>.
                    </p>

                    <h2 className="text-xl font-semibold text-gray-800 mb-4">Rechtliche Hinweise</h2>

                    <h3 className="text-lg font-bold text-gray-700 mb-2">Urheberrecht</h3>
                    <p className="text-gray-600 mb-6">
                        Alle Inhalte unserer Webseite sind urheberrechtlich geschützt. Wir gestatten ausdrücklich die
                        Nutzung aller Daten für den privaten, nicht kommerziellen Gebrauch.
                        Bei Vervielfältigung ist auf die Urheber- und Eigentumsrechte von ubion GmbH ausdrücklich
                        hinzuweisen. Inhalte dürfen in keiner Weise verändert werden und
                        ohne schriftliche Genehmigung nicht auf anderen Internetseiten oder vernetzten Rechnern genutzt
                        werden. Jegliche Nutzung für öffentliche oder kommerzielle Zwecke
                        bedarf der Zustimmung von ubion GmbH. Ein Verstoß gegen diese Bedingungen verpflichtet zur
                        sofortigen Vernichtung aller Inhalte. Die Geltendmachung weiterer
                        Schadensersatzansprüche bleibt vorbehalten.
                    </p>

                    <h3 className="text-lg font-bold text-gray-700 mb-2">Haftung</h3>
                    <p className="text-gray-600 mb-6">
                        Wir sind für eigene Inhalte auf diesen Seiten verantwortlich. Unsere Webseite enthält auch
                        Querverweise (<span className="font-semibold">Links</span>) zu Webseiten anderer Anbieter. Für
                        fremde Inhalte, die über solche Querverweise (Links) erreichbar sind, sind wir jedoch nicht
                        verantwortlich. Das fremde Angebot wurde bei der erstmaligen Verlinkung auf rechtswidrige
                        Inhalte überprüft. Erst wenn wir feststellen oder darauf hingewiesen werden, dass ein Angebot
                        rechtswidrigen Inhalt aufweist, wird dieser Querverweis (Link) aufgehoben.
                    </p>

                    <h3 className="text-lg font-bold text-gray-700 mb-2">Gewährleistung</h3>
                    <p className="text-gray-600">
                        Die Informationen auf unserer Webseite wurden mit größter Sorgfalt erstellt. ubion GmbH
                        übernimmt jedoch keine Gewähr für deren Vollständigkeit oder Geeignetheit für bestimmte
                        Verwendungszwecke. Die Nutzung der auf den Internetseiten zur Verfügung gestellten Inhalte
                        erfolgt auf alleinige Gefahr des Nutzers.
                    </p>
                </div>

            </div>
            <div className="px-8 p-20">
                <Footer/>
            </div>
        </div>

    )
}
